import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import { EWorldAction } from 'libs/utils/world/worldTypes';
import { useContext } from 'react';
import { IDirectionWorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const PanelMessages = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const action = ctxEdit.worldAction;

    const markerInCreation = ctxEdit.markerCreation?.marker as IDirectionWorldMarker | null;

    const noPointExists = !Boolean(markerInCreation);

    const message = noPointExists ? (
        <>{Localization.DIRECTION_ADD1}</>
    ) : (
        <>{Localization.DIRECTION_ADD2}</>
    );

    return (
        <S_PanelMessages className={props.className}>
            {action === EWorldAction.ICON_V2 && (
                <S_Message type="info">{Localization.ICON_ADD}</S_Message>
            )}
            {action === EWorldAction.VARIANT_ICON_V2 && (
                <S_Message type="info">{Localization.VARIANT_ICON_ADD}</S_Message>
            )}
            {action === EWorldAction.TEXT_V2 && (
                <S_Message type="info">{Localization.TEXT_ADD}</S_Message>
            )}
            {action === EWorldAction.IMAGE_V2 && (
                <S_Message type="info">{Localization.IMAGE_ADD}</S_Message>
            )}
            {action === EWorldAction.TEXT && <Message type="info">{Localization.TEXT_ADD}</Message>}
            {action === EWorldAction.DRAW && <></>}
            {action === EWorldAction.DIRECTION && <S_Message type="info">{message}</S_Message>}
            {action === EWorldAction.LINE_V2 && (
                <Message type="info">{Localization.LINE_ADD}</Message>
            )}
            {action === EWorldAction.POLYGON_V2 && (
                <S_Message type="info">{Localization.POLYGON_ADD}</S_Message>
            )}
            {(action === EWorldAction.POLYGON_V2_WALL || action === EWorldAction.LINE_V2_WALL) && (
                <S_Message type="info">{Localization.WALL_ADD}</S_Message>
            )}
            {action === EWorldAction.UPLOAD && (
                <S_Message type="info">{Localization.GPX_UPLOAD_MESSAGE}</S_Message>
            )}
            {action === EWorldAction.INDOOR_STAND && (
                <S_Message type="info">{Localization.CLICK_ANYWHERE_TO_STAND}</S_Message>
            )}
        </S_PanelMessages>
    );
};

const S_PanelMessages = styled.div``;

const S_Message = styled(Message)``;
